import { MantineSize, Menu, Text } from "@mantine/core";
import { useLocation } from "react-router";

import text from "../../Text.module.css";
import { NavLinkItem } from "../../types";
import { getNavProps, getTextProps } from "../../utils";

import type { FC } from "react";

export type HeaderNavMenuItemProps = Pick<NavLinkItem, "label" | "to"> & {
  link?: boolean;
  size?: MantineSize;
};

export const HeaderNavMenuItem: FC<HeaderNavMenuItemProps> = ({
  link = false,
  label,
  size,
  to,
}) => {
  const { pathname } = useLocation();
  const anchorProps = link ? getNavProps(to) : undefined;
  const textProps = getTextProps(pathname, to);

  return (
    <Menu.Item px="lg" py="sm" {...anchorProps}>
      <Text classNames={text} size={size} {...textProps}>
        {label}
      </Text>
    </Menu.Item>
  );
};
